class CartDiscountComponent extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input[name="discount_code"]');
    this.button = this.querySelector('[type="button"]');

    this.button.addEventListener('click', () => this.handleSubmit());
    this.input.addEventListener('keydown', (e) => e.key === 'Enter' && this.handleSubmit());

    // Bind events to all existing remove discount buttons
    this.bindRemoveDiscountEvents();
  }

  async handleSubmit() {
    const code = this.input.value.trim();
    if (!code) return;

    this.setLoading(true);
    console.log('cart:updating');

    try {
      const response = await this.applyDiscount(code);
      console.log('cart:updated', response);

      // Handle the response and refresh cart sections only if discount is valid
      const isValid = this.handleResponse(response, code);
      if (isValid) {
        this.renderContents(response);
      }
    } catch (error) {
      const errorMessage = window.toast_translations?.discount?.error || 'Error applying discount';
      window.toast.error(errorMessage);
      console.error('Apply discount error:', error);
    }

    this.setLoading(false);
  }

  async applyDiscount(newCode) {
    const currentCodes = this.getAttribute('data-current-discount') || '';
    const allCodes = [...currentCodes.split(',').filter(Boolean), newCode].join(',');

    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: allCodes,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    });

    return response.json();
  }

  async removeDiscount(discountCodeToRemove) {
    const currentCodes = this.getAttribute('data-current-discount') || '';
    const allCodes = currentCodes.split(',').filter(Boolean);
    const remainingCodes = allCodes.filter((code) => code !== discountCodeToRemove);
    const updatedCodes = remainingCodes.join(',');

    const response = await fetch(`${Shopify.routes.root}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        discount: updatedCodes,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      }),
    });

    return response.json();
  }

  async handleRemoveDiscount(event) {
    const button = event.target;
    const discountCode = button.getAttribute('data-discount-code');

    if (!discountCode) {
      console.log('Error: Could not identify discount to remove');
      return;
    }

    this.setLoading(true);
    console.log('cart:updating');

    try {
      const response = await this.removeDiscount(discountCode);
      console.log('cart:updated', response);

      const successMessage =
        window.toast_translations?.discount?.removed || 'Discount removed successfully';
      window.toast.success(successMessage);

      // Always refresh cart sections for remove operations (removing is always valid)
      this.renderContents(response);
    } catch (error) {
      const errorMessage = window.toast_translations?.discount?.error || 'Error removing discount';
      window.toast.error(errorMessage);
      console.error('Remove discount error:', error);
    }

    this.setLoading(false);
  }

  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-cart-item-contents',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-cart-footer-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '[data-cart-icon-bubble]',
      },
    ].filter((section) => section.section); // Filter out sections that don't exist
  }

  handleResponse(cart, code) {
    const isValid = cart.discount_codes?.some((d) => d.code === code && d.applicable);

    if (isValid) {
      const successMessage =
        window.toast_translations?.discount?.success || 'Discount applied successfully!';
      window.toast.success(successMessage);
      this.input.value = '';
    } else {
      const errorMessage = window.toast_translations?.discount?.error || 'Invalid discount code';
      window.toast.error(errorMessage);
    }

    // Rebind events in case new remove buttons were added to the DOM
    this.bindRemoveDiscountEvents();

    return isValid;
  }

  renderContents(parsedState) {
    if (!parsedState.sections) return;

    this.getSectionsToRender().forEach((section) => {
      const elementToReplace =
        document.getElementById(section.id)?.querySelector(section.selector) ||
        document.getElementById(section.id);

      if (elementToReplace && parsedState.sections[section.section]) {
        elementToReplace.innerHTML = this.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      }
    });

    // Rebind events after DOM update
    this.bindRemoveDiscountEvents();
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  bindRemoveDiscountEvents() {
    const removeButtons = document.querySelectorAll('[data-remove-discount]');
    removeButtons.forEach((button) => {
      // Remove any existing event listeners to avoid duplicates
      button.removeEventListener('click', this.handleRemoveDiscount);
      // Bind the event listener with proper context
      button.addEventListener('click', (event) => {
        event._handledByDirectBinding = true; // Mark as handled by direct binding
        this.handleRemoveDiscount(event);
      });
    });
  }

  setLoading(isLoading) {
    this.button.disabled = isLoading;
    this.input.disabled = isLoading;
    // Disable all remove discount buttons during loading
    const removeButtons = document.querySelectorAll('[data-remove-discount]');
    removeButtons.forEach((button) => (button.disabled = isLoading));
  }
}

customElements.define('cart-discount-component', CartDiscountComponent);
